var _path, _mask, _g, _mask2, _g2, _rect, _path2, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgViewSignAgreement = function SvgViewSignAgreement(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 661 576",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2F4654",
    d: "M0 0h661v576H0z"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "view-sign-agreement_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 255,
    y: 0,
    width: 406,
    height: 307
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C4C4C4",
    d: "M255 0h406v307H255z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.43,
    fill: "#fff",
    mask: "url(#view-sign-agreement_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M817.813 181.482H468.864A129.192 129.192 0 01598.051 52.351H947a129.192 129.192 0 01-129.187 129.131z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M630.511 129.131H281.565A129.193 129.193 0 01410.755 0h348.946a129.18 129.18 0 01-129.19 129.131zM520.014 292H359.51a129.195 129.195 0 0137.853-91.31 129.17 129.17 0 0191.316-37.821h160.504a129.182 129.182 0 01-37.85 91.312A129.163 129.163 0 01520.014 292z"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "view-sign-agreement_svg__b",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 292,
    width: 464,
    height: 284
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fill: "#C4C4C4",
    d: "M0 292h463.099v284H0z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#view-sign-agreement_svg__b)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M206.894 576h-336.101c.013-32.913 13.128-64.475 36.462-87.744 23.333-23.27 54.975-36.343 87.968-36.346h336.11c-.013 32.916-13.129 64.478-36.465 87.748C271.533 562.928 239.889 576 206.894 576zM40.252 434h-337.045c.013-32.915 13.166-64.478 36.567-87.748 23.4-23.27 55.132-36.342 88.218-36.342h337.035a123.527 123.527 0 01-9.502 47.495 124.062 124.062 0 01-27.049 40.261 124.793 124.793 0 01-40.48 26.897A125.31 125.31 0 0140.252 434z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M302.641 496.685H47.333c.013-32.915 13.157-64.478 36.541-87.748 23.384-23.27 55.094-36.342 88.157-36.342h255.248a123.512 123.512 0 01-9.466 47.497 123.969 123.969 0 01-27.015 40.268 124.606 124.606 0 01-40.447 26.898 125.055 125.055 0 01-47.71 9.427z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 252,
    y: 181.799,
    width: 175.856,
    height: 222.948,
    rx: 16,
    fill: "#959EA7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M266.716 190.629H413.14v200.874H266.716z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 297.619,
    y: 175.913,
    width: 84.617,
    height: 25.753,
    rx: 12.877,
    fill: "#959EA7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 322.637,
    y: 158.253,
    width: 34.583,
    height: 25.753,
    rx: 7,
    fill: "#959EA7"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 310.128,
    y: 217.853,
    width: 57.392,
    height: 5.886,
    rx: 2.943,
    fill: "#C4C4C4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 282.168,
    y: 238.456,
    width: 113.313,
    height: 5.886,
    rx: 2.943,
    fill: "#C4C4C4"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 282.168,
    y: 251.7,
    width: 113.313,
    height: 5.886,
    rx: 2.943,
    fill: "#C4C4C4"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 282.168,
    y: 264.945,
    width: 108.163,
    height: 5.886,
    rx: 2.943,
    fill: "#C4C4C4"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 282.168,
    y: 317.187,
    width: 108.163,
    height: 5.886,
    rx: 2.943,
    fill: "#C4C4C4"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 282.168,
    y: 278.189,
    width: 113.313,
    height: 5.886,
    rx: 2.943,
    fill: "#C4C4C4"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 282.168,
    y: 330.431,
    width: 85.353,
    height: 5.886,
    rx: 2.943,
    fill: "#C4C4C4"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 282.168,
    y: 291.434,
    width: 110.37,
    height: 5.886,
    rx: 2.943,
    fill: "#C4C4C4"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 282.168,
    y: 304.678,
    width: 113.313,
    height: 5.886,
    rx: 2.943,
    fill: "#C4C4C4"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 282.168,
    y: 365.014,
    width: 42.676,
    height: 2.943,
    rx: 1.472,
    fill: "#C4C4C4"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 352.805,
    y: 365.014,
    width: 42.676,
    height: 2.943,
    rx: 1.472,
    fill: "#C4C4C4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M399.853 350.838l-10.225-5.986-3.866 18.33 14.091-12.344zM424.404 284.665l10.907 6.385-33.521 57.26-10.907-6.384z",
    fill: "#33BB40"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M440.367 257.397l10.907 6.385-2.394 4.09 6.816 3.991-21.549 36.811-2.045-1.197 19.953-34.084-4.772-2.794-10.375 17.724-10.907-6.385 14.366-24.541z",
    fill: "#33BB40"
  })));
};

export default SvgViewSignAgreement;